module.exports = __webpack_public_path__ + "static/media/crew-icon.8d0370b2.png";